'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
var button = require('./button-c50f4784.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
var index_es = require('./index.es-1f72f6f2.js');
require('./index.esm-c41adfff.js');
var index$4 = require('./index-c25ba35c.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var component$m = require('./component-0d3539a5.js');

(function (BottomModalVariant) {
    BottomModalVariant["DEFAULT"] = "default";
    BottomModalVariant["CENTERED"] = "centered";
})(exports.BottomModalVariant || (exports.BottomModalVariant = {}));
var Wrapper = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px;\n\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 20px;\n\n  ", ";\n"])), function (_a) {
    var variant = _a.variant;
    return (variant === exports.BottomModalVariant.CENTERED ? 'text-align: center;' : null);
});
var Title = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: 600 28px/32.81px ", ";\n  color: ", ";\n"], ["\n  font: 600 28px/32.81px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var Subtitle = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/16.75px ", ";\n  color: ", ";\n  margin-top: 10px;\n"], ["\n  font: 400 14px/16.75px ", ";\n  color: ", ";\n  margin-top: 10px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$sharedGreyDark;
});
var Content = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font: 400 14px/22px ", ";\n  margin: 16px 0 24px;\n"], ["\n  color: ", ";\n  font: 400 14px/22px ", ";\n  margin: 16px 0 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var StyledButton = styled__default(button.Button)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  height: 50px;\n  margin-right: 12px;\n  font-size: 16px;\n  flex: 1 1 auto;\n  background-color: ", ";\n  border: ", ";\n  color: ", ";\n  ", "\n"], ["\n  height: 50px;\n  margin-right: 12px;\n  font-size: 16px;\n  flex: 1 1 auto;\n  background-color: ",
    ";\n  border: ",
    ";\n  color: ",
    ";\n  ",
    "\n"])), function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return variant === constants.BUTTON_VARIANT.SECONDARY ? theme.colors.$white : theme.colors.$primary;
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return "1px " + (variant === constants.BUTTON_VARIANT.SECONDARY ? theme.colors.$sharedGreyDark : theme.colors.$primary) + " solid";
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return variant === constants.BUTTON_VARIANT.SECONDARY ? theme.colors.$sharedGreyDark : theme.colors.$white;
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return (variant === constants.BUTTON_VARIANT.PRIMARY
        ? "&:hover {\n    background-color: " + theme.colors.$primary + ";\n  }\n\n  &:active,\n  &:focus {\n    outline-color: " + theme.colors.$primary + ";\n  } "
        : null);
});
var ButtonsWrapper = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap;\n"])));
var IconWrapper = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  height: 45px;\n  width: 45px;\n  background-color: ", ";\n  border-radius: 50%;\n  margin: 4px auto 16px;\n"], ["\n  height: 45px;\n  width: 45px;\n  background-color: ", ";\n  border-radius: 50%;\n  margin: 4px auto 16px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.$greyLight;
});
var Icon = styled__default(index_es.FontAwesomeIcon)(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  font-size: 20px;\n  padding: 0.5em;\n  color: ", ";\n"], ["\n  font-size: 20px;\n  padding: 0.5em;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.$greyDark;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

var BottomModal = function (_a) {
    var isVisible = _a.isVisible, title = _a.title, content = _a.content, buttons = _a.buttons, onClose = _a.onClose, subtitle = _a.subtitle, className = _a.className, _b = _a.showCloseIcon, showCloseIcon = _b === void 0 ? true : _b, _c = _a.variant, variant = _c === void 0 ? exports.BottomModalVariant.DEFAULT : _c, iconProps = _a.iconProps;
    var getButtons = function () { return (React__default.createElement(ButtonsWrapper, { "data-testid": "bottom-mobile-buttons-wrapper" }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function (_a) {
        var buttonTitle = _a.title, handler = _a.handler, buttonVariant = _a.variant, isLoading = _a.isLoading, disabled = _a.disabled, dataCy = _a.dataCy;
        return (React__default.createElement(StyledButton, { key: buttonTitle, "data-testid": buttonTitle + "-button", "data-cy": dataCy, onClick: handler, text: buttonTitle, variant: buttonVariant || constants.BUTTON_VARIANT.PRIMARY, loading: isLoading, disabled: disabled }));
    }))); };
    var buildContent = function () { return (React__default.createElement(Wrapper, { "data-testid": "bottom-mobile-wrapper", variant: variant },
        iconProps && (React__default.createElement(IconWrapper, { "data-testid": "bottom-mobile-icon" },
            React__default.createElement(Icon, { className: "icon-block-icon", icon: iconProps }))),
        title && React__default.createElement(Title, { "data-testid": "bottom-mobile-title" }, title),
        subtitle && React__default.createElement(Subtitle, { "data-testid": "bottom-mobile-subtitle" }, subtitle),
        content && React__default.createElement(Content, { "data-testid": "bottom-mobile-content" }, content),
        getButtons())); };
    return (React__default.createElement(component$m.MobileModal, { className: className, content: buildContent(), visible: isVisible, withExitButton: showCloseIcon, onClose: onClose }));
};
BottomModal.propTypes = {
    buttons: index$4.propTypes.arrayOf(index$4.propTypes.any),
};
BottomModal.defaultProps = {
    buttons: [],
};

exports.BottomModal = BottomModal;
